import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "@components"
import {useDigitalShelfReportForm} from "../../@hooks";

export default function CreateReportButton() {
    const { handleOpenForm, isLoadingDrawer } = useDigitalShelfReportForm()

    return <Box componet="span" sx={{ mr: 1 }} data-tour="ds-general-create-report">
        <ActionButton
            isLoading={isLoadingDrawer}
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}